//API TO GENERATE PDF
import { fetch } from '../../utils';
import Backend from '../../backend';

export const getPDF = async (type, data) =>
  fetch(Backend.pdfApi(`/generate/${type}`), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(async res => {
      // Only Studio receives a binary image. All other callers retain the
      // established base64 PDF response handling below.
      if (type === 'hot-topic-studio') {
        if (!res.ok) {
          throw new Error((await res.text()) || `Studio image generation failed (${res.status})`);
        }

        // During a rolling deployment the web app can reach an older
        // pdf-server which still returns a base64 PNG as text/plain. Decode
        // that response only for Studio, so existing PDF/SOS callers keep
        // their unchanged contract.
        const contentType = (res.headers.get('Content-Type') || '').split(';')[0];
        if (contentType === 'text/plain') {
          const binaryString = atob(await res.text());
          const bytes = new Uint8Array(binaryString.length);
          for (let i = 0; i < binaryString.length; i += 1) {
            bytes[i] = binaryString.charCodeAt(i);
          }
          return new Blob([bytes], { type: 'image/png' });
        }

        const blob = await res.blob();
        return blob.type ? blob : new Blob([blob], { type: contentType || 'image/jpeg' });
      }

      // Extract filename from Content-Disposition header to determine MIME type
      const contentDisposition = res.headers.get('Content-Disposition') || '';
      const filename = contentDisposition.match(/filename=([^;]+)/)?.[1] || '';

      let mimeType = 'application/octet-stream';
      if (filename.includes('.pdf')) {
        mimeType = 'application/pdf';
      } else if (filename.includes('.png')) {
        mimeType = 'image/png';
      }

      // Server is now sending base64 encoded data, decode it to binary
      return res.text().then(base64Data => {
        const binaryString = atob(base64Data);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        return new Blob([bytes], { type: mimeType });
      });
    })
    .catch(error => {
      throw error;
    });
